import React from "react";
import { CheckCircle2 } from "lucide-react";
import { Button } from "./ui/button";
import { useContent } from "../contexts/ContentContext";

export default function About({ onEnquire }) {
  const { content } = useContent();
  const { aboutSection } = content;
  return (
    <section id="about" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl ring-1 ring-slate-200">
              <img
                src={aboutSection.image}
                alt="About Zenova"
                className="w-full h-[460px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a3d38]/40 to-transparent" />
            </div>
            <div className="absolute -bottom-6 -right-6 hidden md:block rounded-2xl bg-orange-500 text-white p-6 shadow-xl max-w-[220px]">
              <div className="text-3xl font-extrabold">5,000+</div>
              <div className="text-sm font-medium opacity-90 mt-1">Happy families powered with clean energy</div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="inline-block px-3 py-1 rounded-full bg-emerald-50 text-[#0a4f47] text-xs font-semibold tracking-wider mb-4">
              {aboutSection.eyebrow}
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight">
              {aboutSection.title} <span className="text-orange-500">{aboutSection.titleAccent}</span>
            </h2>
            {aboutSection.paragraphs.map((p, i) => (
              <p key={`para-${i}-${p.slice(0, 20)}`} className="text-slate-600 mt-4 leading-relaxed">
                {p}
              </p>
            ))}
            <ul className="mt-6 space-y-3">
              {aboutSection.highlights.map((h) => (
                <li key={h} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-orange-500 mt-0.5 flex-shrink-0" />
                  <span className="text-slate-700">{h}</span>
                </li>
              ))}
            </ul>
            <Button
              onClick={onEnquire}
              className="mt-8 bg-[#0a4f47] hover:bg-[#0e6e63] text-white h-12 px-7 rounded-md font-semibold shadow-md hover:shadow-lg transition-shadow"
            >
              Schedule Free Survey
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
